import React, { createContext, useContext, useCallback } from "react";

// Form modal (QuoteDialog.jsx) devre dışı bırakıldı; "Teklif Al" butonları artık
// doğrudan WhatsApp'a yönlendiriyor. QuoteDialog.jsx ve /api/quotes silinmedi,
// ileride tekrar forma dönülmek istenirse burada yeniden bağlanabilir.
const QuoteContext = createContext(null);

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;

export const QuoteProvider = ({ children }) => {
  const openQuote = useCallback(() => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }, []);

  return (
    <QuoteContext.Provider value={{ openQuote }}>
      {children}
    </QuoteContext.Provider>
  );
};

export const useQuote = () => {
  const ctx = useContext(QuoteContext);
  if (!ctx) throw new Error("useQuote must be used within QuoteProvider");
  return ctx;
};
